<template>
  <div class="home bg" :class="(state.isLoading) ? 'is-loading' : 'loaded'">
      <Clouds />
      <landscape-message></landscape-message>
      <Header></Header>
      <!-- <div class="product-instructions">
        <LocalizedLink to="/" class="close-detail position-absolute"></LocalizedLink>
        <arrow key="arrowleft" arrow-class="arrow-left" target="/grow-with-me"></arrow>
        <arrow key="arrowright" arrow-class="arrow-right" target="/video"></arrow>
        <div class="product-copy-container">
          <transition name="bounce">
            <div v-if="show">
              <div class="product-title">
                <div class="product-num">5</div>
                <div class="product-name" v-html="$t('safety_screen.title')"></div>
              </div>
              {{ $i18n.messages['en']['landing_screen'] }}
              {{$route.name}}
              <div class="product-inst" v-html="$t('safety_screen.content')"></div>
            </div>
          </transition>
        </div>
      </div> -->
      <router-view/>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/particle/Header.vue'
import Clouds from '@/components/particle/Clouds.vue'

// import LocalizedLink from '@/components/LocalizedLink'
// import Arrow from "@/components/Arrow";

import { inject } from "vue";
import LandscapeMessage from "../components/particle/LandscapeMessage";

export default {
  components: {
    LandscapeMessage,
    Header,
    Clouds,
    // Arrow,
    // LocalizedLink
  },
  setup() {
    const store = inject("store");
    return {
      state: store.state
    };
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 800);
  }

}
</script>

<style scoped lang="scss">
.home {
	transition: opacity 0.25s;
	opacity: 0;
	visibility: hidden;
}
.is-loading {
	visibility: hidden;
}
.loaded {
	visibility: visible;
	opacity: 1;
}
.router-link-exact-active {
  text-decoration: underline;
  font-weight: bold;
}
.bg {
  background-image: url("../assets/imgs/bg.jpg");
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
}
@media (max-width: 414px) {
  .bg {
    overflow: hidden;
    background-image: url("../assets/imgs/sm-bg.jpg");
  }
}
</style>
